import React, { Component } from "react";
import { Row, Col, Card, CardBody, FormGroup, Button,  Label, Input, Container, Spinner, Modal, ModalHeader, ModalBody, } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import Dropzone from "react-dropzone";
import Select from "react-select";
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import { Link } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { BaseUrl } from "../../helpers/Baseurl"
import axios from "axios";


class AddLocation extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 1, 'create' )){
      this.props.history.push('/locations')
    }
    this.state = {
      loading: false,
      lodingstate: false,
      loadingcity:false,
      placeloading:false,
      model_state:false,
      stateloading:false,
      model_city:false,
      cityloading:false,
      is_place:false,
      is_destination:false,
      parent_destini : false,

      selectedCountry: { label: "Select Country", value: null },
      selectedState:{ label: "Select State", value: null },
      selectedCity:{ label: "Select City", value: null },
      selectedDistrict:{ label: "Select District", value: null },
      selectedRailway: { label: "Select Place", value: "" },
      selectedAirport: { label: "Select Place", value: "" },
      selectedBusStation: { label: "Select Place", value: "" },
      selectedDestination: { label: "Select Destination", value: "" },

      all_states:[],
      Districts:[],

      StateGroup:[],
      CountriesGroup:[],
      CityGroup:[],
      DestinationGroup:[],
      Destination:"",

      selectedDestinations: [],
      All_DestinationGroup:[],

      PlacesGroup: [],

      added_places:[],


      selectedFiles: [],
      rejectedFiles:[],
      breadcrumbItems: [
        { title: "Locations", link: "/locations" },
        { title: "Add New Location", link: "#" },
      ],
      count:1,
      
    };
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
  }
    this.onInputChange = this.onInputChange.bind(this)
    this.handleAddSubPlacesSubmit = this.handleAddSubPlacesSubmit.bind(this)
    this.handleAddStateSubmit = this.handleAddStateSubmit.bind(this)
    this.handleAddCitySubmit = this.handleAddCitySubmit.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSelectCountry = this.handleSelectCountry.bind(this);
    this.handleSelectState = this.handleSelectState.bind(this);
    this.handleSelectCity = this.handleSelectCity.bind(this);
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this);
    this.handleRejectedFiles = this.handleRejectedFiles.bind(this);
    this.handleSelectedRailway = this.handleSelectedRailway.bind(this)
    this.handleSelectedAirport = this.handleSelectedAirport.bind(this)
    this.handleSelectedBusStation = this.handleSelectedBusStation.bind(this)
    this.handleSelectedDestinationsDistance = this.handleSelectedDestinationsDistance.bind(this)
    this.handleFormField = this.handleFormField.bind(this)
    this.removeInput = this.removeInput.bind(this);
    this.addInput = this.addInput.bind(this);
    this.tog_state = this.tog_state.bind(this);

  }
  tog_state() {
    this.setState(prevState => ({
      model_state: !prevState.model_state
    }));
    this.removeBodyCss();
  }
  tog_city() {
    this.setState(prevState => ({
      model_city: !prevState.model_city
    }));
    this.removeBodyCss();
  }

  tog_place() {
    this.setState(prevState => ({
      model_place: !prevState.model_place
    }));
    this.removeBodyCss();
  }
  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  addInput(){
    const {count, All_DestinationGroup} = this.state
    if(count < All_DestinationGroup[0].options.length ){
      this.setState({count:count+1})
    }
  }

  removeInput(){
    const {count, selectedDestinations} = this.state
    let newdata = selectedDestinations
    newdata.pop()
    this.setState({count:count-1, selectedDestinations:newdata })

  }

  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    toastr.error("Something Went Wrong", "")
    this.props.history.push('/locations')
  }

  async componentDidMount() { 

    this.loadCountryData();
 }

 async loadCountryData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/location/countries/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              let selectedCountry= { label: "Select Country", value: null }
              data.map(country => {
                  if(country.name.toLowerCase() === 'india'){
                    selectedCountry= { label: country.name, value: country.id }
                    this.loadStateData(country.id)
                  }
                  options.push({ label: country.name, value: country.id })
                })
             
                let CountriesGroup = [
                  { 
                      label: "Country",
                      options: options
                  }
              ];
              this.setState({ CountriesGroup:CountriesGroup,selectedCountry:selectedCountry  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadStateData(country){
   this.setState({lodingstate:true})
    const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/states/${country}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(state => {
                  options.push({ label: state.name, value: state.id })
                })
             
                let StateGroup = [
                  { 
                      label: "State",
                      options: options
                  }
              ];
              this.setState({ StateGroup:StateGroup, lodingstate:false, all_states:data   })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

 async loadCityData(state){
  this.setState({loadingcity:true})
  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/cities/${state}/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.map(city => {
                  options.push({ label: city.name, value: city.id })
                })
             
                let CityGroup = [
                  { 
                      label: "City",
                      options: options
                  }
              ];
              this.setState({ CityGroup:CityGroup, loadingcity:false  })      
             
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  async loadDestinationData(destination){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${destination}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let selectedRailway = { label: "Select Place", value: "" }
                let selectedAirport = { label: "Select Place", value: "" }
                let selectedBusStation = { label: "Select Place", value: "" }
                let selectedCountry = { label: data.location.country.name, value: data.location.country.id }
                let selectedState ={ label: data.location.state.name, value: data.location.state.id }
                let selectedCity ={ label: data.location.city.name, value: data.location.city.id }
                let selectedDistrict = { label: data.location.district?data.location.district.name:"Select District", value: data.location.district?data.location.district.id:null }
                let elevation = data.location.elevation
                let area = data.location.area
                let weather = data.location.weather
                let climate = data.location.climate
                let bus_station_distance = data.location.bus_station_distance
                let railway_distance = data.location.railway_distance
                let airport_distance = data.location.airport_distance
                let pincode = data.location.zip_code
                let district = data.location.district
                let description = data.location.description
                if(data.location.nearest_railway_station){
                  selectedRailway = { label: data.location.nearest_railway_station.name, value: data.location.nearest_railway_station.id }
                }
                if(data.location.nearest_airport){
                  selectedAirport = { label: data.location.nearest_airport.name, value: data.location.nearest_airport.id }
                }
                if(data.location.nearest_bus_station){
                  selectedBusStation = { label: data.location.nearest_bus_station.name, value: data.location.nearest_bus_station.id }
                }
                
                this.setState({ selectedRailway:selectedRailway,
                                selectedAirport:selectedAirport,
                                selectedBusStation:selectedBusStation,
                                elevation:elevation,
                                area:area,
                                weather:weather,
                                climate:climate,
                                pincode:pincode,
                                district:district,
                                description:description,
                                bus_station_distance:bus_station_distance,
                                railway_distance:railway_distance,
                                airport_distance:airport_distance, selectedState, selectedCountry,
                                selectedCity,selectedDistrict,
                              is_place: true })      
                
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadStateLocationsData(filter_data){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/locations/location/locations/?size=50&${filter_data}`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              let options = []
              data.results.map(place => {
                  options.push({ label: place.name, value: place.id })
                  })
              
                  let PlacesGroup = [
                  { 
                      label: "Locations",
                      options: options
                  }
            ];
              
              this.setState({ PlacesGroup:PlacesGroup , model_place:false, placeloading:false, lodingNearestPlace:false })      
              
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
  }

  async loadDestinations(state){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/destinations/${state}/`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                  })
              
                  let DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ DestinationGroup:DestinationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

  async loadAllDestinations(filer_queryset){

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                let options = []
                data.results.map(destination => {
                    options.push({ label: destination.name, value: destination.id })
                  })
              
                  let All_DestinationGroup = [
                    { 
                        label: "Destination",
                        options: options
                    }
                ];
                this.setState({ All_DestinationGroup:All_DestinationGroup  })      
              
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        )  
  }

 handleSelectCountry = selectedCountry => {
    this.loadStateData(selectedCountry.value)
    this.setState({ selectedCountry  })
  };

  onInputChange(e){
    this.loadAllDestinations(`?parent=null&search=${e}`)
  }

  handleLoadNearestPlaces(filter_data){
    if(this.state.selectedState.value){
      this.setState({lodingNearestPlace:true})
      this.loadStateLocationsData(filter_data)
    }else{
      toastr.error("Please Select State First", "")
    }
    
  }

  handleSelectState = selectedState => {
    const {all_states } = this.state
    let options= []
    for (let i in all_states){
      if(all_states[i].id === selectedState.value){
        let district = all_states[i].district
        for (let j in district){
          options.push({ label: district[j].name, value: district[j].id })
        }
      }
    }
    let Districts = [
      { 
          label: "District",
          options: options
      }
    ];
    this.loadCityData(selectedState.value)
    this.loadDestinations(selectedState.value)
    this.setState({ selectedState, Districts  })
 };

 handleSelectedDistrict = selectedDistrict => {
  this.setState({ selectedDistrict })

 }
    
 handleSelectCity = selectedCity => {
    this.setState({ selectedCity });
  };

  handleSelectedRailway = selectedRailway => {
    this.setState({ selectedRailway  })
  }

  handleSelectedAirport = selectedAirport => {
    this.setState({ selectedAirport  })
  }
  handleSelectedBusStation = selectedBusStation => {
    this.setState({ selectedBusStation  })
  }

  handleSelectedDestinations = (selectedDestination) => {  
      this.loadDestinationData(selectedDestination.value)
      this.setState({ selectedDestination })
  }

  handleSelectedDestinationsDistance = (selectedStation, index) => {
    
    const {selectedDestinations} = this.state
    if(selectedDestinations.includes(selectedStation.value)){
      toastr.error(`${selectedStation.label} already selected`,"")
    }
    else{
      let newdata = selectedDestinations
      let value = selectedStation.value
      if ((newdata.length)-1 < index){
        newdata.push(value)
      }else{
          newdata[index] = value
      }
      this.setState({ selectedDestinations:newdata })
    }

  } 

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ selectedFiles: files });
  };

  handleRejectedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size)
      })
    );
    this.setState({ rejectedFiles : files });
  } 

  /**
   * Formats the size
   */
  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleAddState(){
    if (this.state.selectedCountry.value === null){
      toastr.error(`Please Select Country First`,"")
    }else{
      this.tog_state()
    }
  }

  

  handleAddCity(){
    if (this.state.selectedState.value === null){
      toastr.error(`Please Select State First`,"")
    }else{
      this.tog_city()
    }
  }

  handleFormField = e =>{
    this.loadAllDestinations('?parent=null')
    if(e.target.value === "is_place"){

      this.setState({parent_destini : true, is_destination:false, count:1, selectedDestinations:[]})
      
    }else{
      let selectedRailway = { label: "Select Place", value: "" }
      let selectedAirport = { label: "Select Place", value: "" }
      let selectedBusStation = { label: "Select Place", value: "" }
      let selectedDestination = { label: "Select Destination", value: "" }
      let selectedState ={ label: "Select State", value: null }
      let selectedCity ={ label: "Select City", value: null }
      let elevation = ""
      let area = ""
      let weather = ""
      let climate = ""
      let bus_station_distance = ""
      let railway_distance = ""
      let airport_distance = ""
      let pincode = ""
      let district = ""
      let description = "" 

      this.setState({ is_destination:true, is_place:false, parent_destini:false,
                      selectedRailway,
                      selectedAirport,
                      selectedBusStation,
                      selectedDestination,
                      elevation:elevation,
                      area:area,
                      weather:weather,
                      climate:climate,
                      bus_station_distance:bus_station_distance,
                      railway_distance:railway_distance,
                      airport_distance:airport_distance,
                      selectedState,selectedCity,
                      pincode:pincode, district:district, description:description,

                    })
    }

  }

  handleAddSubPlacesSubmit(e, values){
    const { added_places, selectedCountry,selectedState,selectedCity, selectedFiles,selectedDistrict } = this.state
   
    if(selectedFiles.length === 0){
    
      toastr.error(`Select Images`,"") 
    }else  if (!selectedCity.value  && !selectedDistrict ){
      toastr.error(`Select District or City`,"") 
    }else{
      this.setState({ placeloading: true })
      const formData = new FormData();
        const img = selectedFiles
        for(let i=0 ; i<img.length; i++){
          formData.append(
            "image",
            selectedFiles[i]
        );
      }
      formData.append("name",values.place_name)
      formData.append("country",selectedCountry.value)
      formData.append("state",selectedState.value)
      formData.append("city",selectedCity.value)
      formData.append("district",selectedDistrict.value)
      formData.append("zip_code",document.getElementById("zip_code").value)
      formData.append("description",document.getElementById("textarea").value)
      formData.append("elevation",document.getElementById("elevation").value)
      formData.append("area",document.getElementById("area").value)
      formData.append("weather",document.getElementById("weather").value)
      formData.append("climate",document.getElementById("climate").value)
        axios.post(
          `${BaseUrl}/api/locations/add_location/`,
          formData,
          {
              headers: {
                  "Content-type": "multipart/form-data",
                  'Authorization': `Bearer ${this.obj.access}`
              },                    
          }
      )
      .then(res => {
          
          let places = added_places
          places.push(res.data.id)
          this.setState({ added_places:places, placeloading: false, model_place:false  })
          // this.loadStateLocationsData(selectedState.value)
      })
      .catch(err => {
        toastr.error(`Somthing Went Wrong`,"") 
        this.setState({ placeloading: false })
          console.log(err, "----------------------error");
      })
    }
  }

  handleAddStateSubmit(e, value){
    this.setState({ stateloading: true})
    let new_data = {}
          new_data["name"] = value.name
          new_data["country"] = this.state.selectedCountry.value
          axios.post(
            `${BaseUrl}/api/locations/states/`,
            new_data,
            {
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${this.obj.access}`
                },                    
            }
          ).then(res => {
            let selectedState = { label: res.data.name, value: res.data.id }
            this.loadStateData(this.state.selectedCountry.value)
            this.setState({model_state:false, stateloading:false, selectedState:selectedState })

          }).catch(err => {
            console.log(err, "----------------------error");
            })
  }

  handleAddCitySubmit(e, value){
    this.setState({ cityloading: true})
    let new_data = {}
          new_data["name"] = value.name
          new_data["state"] = this.state.selectedState.value
          axios.post(
            `${BaseUrl}/api/locations/cities/`,
            new_data,
            {
                headers: {
                    "Content-type": "application/json",
                    'Authorization': `Bearer ${this.obj.access}`
                },                    
            }
          ).then(res => {
            toastr.success(`City ${res.data.name} Added`,"") 
            let selectedCity = { label: res.data.name, value: res.data.id }
            this.loadCityData(this.state.selectedState.value)
            this.setState({model_city:false, cityloading:false, selectedCity:selectedCity })

          }).catch(err => {
            console.log(err, "----------------------error");
            })
  
  }

  handleSubmit(e, values) {
        let description = document.getElementById("textarea").value

        if(this.state.selectedFiles.length === 0){
    
          toastr.error(`Select Images`,"") 
        }else if (this.state.is_place && this.state.selectedDestination.value === "" ){
            toastr.error(`Select Destination`,"")
        }else{
          this.setState({ loading: true })
          const {selectedFiles, is_place, is_destination} = this.state
          let distance = []
          let destinations = this.state.selectedDestinations
          if (destinations.length === 0){
            destinations = null
            distance = null
          }
          else{
            for (let i=0; i<this.state.selectedDestinations.length; i++){
              distance.push(document.getElementById(`diatance-${i}`).value)
            }
          }
          const formData = new FormData();
          const img = selectedFiles
          for(let i=0 ; i<img.length; i++){
            formData.append(
              "image",
              selectedFiles[i]
          );
          }
          if (is_place){
            formData.append("destination_distance",values.destination_distance)
          }else{
            formData.append("destination_distance","")
          }
          formData.append("name",values.name)
          formData.append("country",this.state.selectedCountry.value)
          formData.append("state",this.state.selectedState.value)
          formData.append("city",this.state.selectedCity.value)
          formData.append("district",this.state.selectedDistrict.value)
          formData.append("zip_code",values.zip_code)
          formData.append("description",description)
          formData.append("nearest_bus_station",this.state.selectedBusStation.value)
          formData.append("bus_station_distance",values.bus_station_distance)
          formData.append("nearest_railway_station",this.state.selectedRailway.value)
          formData.append("railway_distance",values.railway_distance)
          formData.append("nearest_airport",this.state.selectedAirport.value)
          formData.append("airport_distance",values.airport_distance)
          formData.append("elevation",values.elevation)
          formData.append("area",values.area)
          formData.append("weather",values.weather)
          formData.append("climate",values.climate)
          formData.append("coordinates",values.coordinates)
          formData.append("parent",this.state.selectedDestination.value)
          
          
          axios.post(
            `${BaseUrl}/api/locations/add_location/`,
            formData,
            {
                headers: {
                    "Content-type": "multipart/form-data",
                    'Authorization': `Bearer ${this.obj.access}`
                },                    
            }
        )
        .then(res => {
          if(this.state.added_places.length > 0){
            let places_data = {"ids":this.state.added_places, "parent":res.data.id}
            const requestOptions = {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
              body: JSON.stringify(places_data)
              };
              fetch(`${BaseUrl}/api/locations/places-assign-parent/`,requestOptions)
                    .then(res => 
                        {if(res.status >= 400){
                          toastr.error("Something Went Wrong When Assign Parent", "")
                        }
                    }
                )
          }
          if(destinations !== null && is_destination === true){
              let new_data = {}
              new_data["from_destination"] = res.data.id
              new_data["destination"] = destinations
              new_data["distance"] = distance
              axios.post(
                `${BaseUrl}/api/locations/location/destination_distance/`,
                new_data,
                {
                    headers: {
                        "Content-type": "application/json",
                        'Authorization': `Bearer ${this.obj.access}`
                    },                    
                }
              ).then(newres => {
        
              }).catch(err => {
                console.log(err, "----------------------error");
                })
        
            }// end if block 
            toastr.success(`${res.data.name} Added Successfully`,"")
            this.props.history.push("/locations")
        })
        .catch(err => {
          // console.log(res.status, "--------------")
          // console.log(res.data, "---------------")
          toastr.error(`Somthing Went Wrong`,"") 
          this.setState({ loading: false })
            console.log(err, "--------------------error");
        })
        }
      }

  render() {
    const { CountriesGroup, selectedCountry, selectedState, StateGroup, selectedCity,
            CityGroup,lodingstate, loadingcity, selectedRailway, selectedAirport,
            selectedBusStation, selectedDestination, PlacesGroup,
            All_DestinationGroup ,lodingNearestPlace } = this.state;
    const CustomMenu = ({ innerRef, innerProps, isDisabled, children }) =>
    lodingstate? (
      <Spinner className="me-2 mt-2" color="primary" />
    ):(
        !isDisabled ? (
            <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                {has_Permission(this.obj.user, 9, 'create' )?
                <Link to="#" onClick={() => this.handleAddState()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
                :null}
                </div>
        ) : null
    )

        const CustomCity = ({ innerRef, innerProps, isDisabled, children }) =>
        loadingcity?
        ( <Spinner className="me-2 mt-2" color="primary" />):(
        !isDisabled ? (
            <div ref={innerRef} {...innerProps} className="customReactSelectMenu">
                {children}
                {has_Permission(this.obj.user, 9, 'create' )?
                <Link to="#" onClick={() => this.handleAddCity()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
                :null}
            </div>
        ) : null
        )

        const AddPlaces = ({ innerRef, innerProps, isDisabled, children }) =>
        lodingNearestPlace?
        ( <Spinner className="me-2 mt-2" color="primary" />):(
        !isDisabled ? (
          <div id="add_state" ref={innerRef} {...innerProps} className="customReactSelectMenu">
              {children}
              <Link to="#" onClick={() => this.tog_place()}  className="text-warning"><i className="mdi mdi-plus font-size-18"></i></Link>
          </div>
      ) : null)
   
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Location" breadcrumbItems={this.state.breadcrumbItems} />
            <AvForm className="needs-validation" onValidSubmit={this.handleSubmit} >
              <Row>
                <Col xl="6">
                  <Card>
                    <CardBody> 
                      <h4 className="card-title">Location Detail</h4>
                        <Row>
                          <Col md="12">
                            <div className="mb-3">
                              <Label className="form-label " htmlFor="name">Name</Label>
                              <AvField
                                name="name"
                                placeholder="Name"
                                type="text"
                                errorMessage="Enter Place Name"
                                className="form-control"
                                validate={{ required: { value: true } }}
                                id="name"
                                
                              />
                            </div>
                          </Col> 
                        </Row>
                        <Row>
                          <Col md={6}>   
                            <div className="form-check mb-3">
                                <Input className="form-check-input" type="radio" name="exampleRadios" onChange={(e) =>this.handleFormField(e)} id="exampleRadios1" value="is_place"  />
                                <Label className="form-check-label" htmlFor="exampleRadios1">
                                    Is Place 
                                </Label>
                            </div>
                          </Col>
                          <Col md={6}>   
                            <div className="form-check mb-3">
                                <Input className="form-check-input" type="radio" name="exampleRadios" onChange={(e) =>this.handleFormField(e)} id="exampleRadios2" value="is_destination"  />
                                <Label className="form-check-label" htmlFor="exampleRadios2">
                                    Is Destination
                                </Label>
                            </div>
                          </Col>
                         
                        </Row>
                        
                        <Row>
                          {this.state.parent_destini?
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Parent Destination</Label>
                                <Select 
                                onInputChange = {this.onInputChange}
                                menuPlacement= {"top"}
                                value={selectedDestination}
                                onChange={this.handleSelectedDestinations}
                                options={All_DestinationGroup}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>:"" }
                          {this.state.is_place?
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label" htmlFor="destination_distance">Distance From Destination (Km)</Label>
                                    <AvField
                                    name="destination_distance"
                                    placeholder="Distance From Destination"
                                    type="text"
                                    validate={{ required: { value: true } }}
                                    className="form-control"
                                    id="destination_distance" 
                                    />
                                </div>
                            </Col> 
                            :""}
                        </Row>  
                        
                        {this.state.is_destination||this.state.is_place?  
                        <>
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">Country</Label>
                                <Select 
                                value={selectedCountry}
                                onChange={this.handleSelectCountry}
                                options={CountriesGroup}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                       
                          <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">State</Label>
                                  <Select 
                                  value={selectedState}
                                  onChange={this.handleSelectState}
                                  options={StateGroup}
                                  components={{ Menu: CustomMenu }}
                                  classNamePrefix="select2-selection"
                                  />

                              </div>
                          </Col>
                        </Row> 
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">District</Label>
                                <Select 
                                value={this.state.selectedDistrict}
                                onChange={this.handleSelectedDistrict}
                                options={this.state.Districts}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                          <Col md="6">
                            <div className="mb-3">
                                <Label className="form-label">City</Label>
                                <Select 
                                value={selectedCity}
                                onChange={this.handleSelectCity}
                                options={CityGroup}
                                components={{ Menu: CustomCity }}
                                classNamePrefix="select2-selection"
                                />

                            </div>
                          </Col>
                        </Row> 
                        <Row>
                          <Col md="6">
                            <div className="mb-3">
                              <AvField
                                name="zip_code"
                                label="Pin Code"
                                value = {this.state.pincode?this.state.pincode:""}
                                placeholder="Enter Only number"
                                type="number"
                                errorMessage="Enter Only Number"
                                validate={{
                                  required: { value: true },
                                  
                                  maxLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be less than 7 digit"},
                                  minLength: {
                                    value: 6,
                                    errorMessage: "Numbers must be Grater than 5 digit"}   
                                }}
                                id="zip_code"
                              />
                            </div>
                          </Col>
                          <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="coordinates">Coordinates</Label>
                                <AvField
                                  name="coordinates"
                                  placeholder="Coordinates"
                                  type="text"
                                  className="form-control"
                                  validate={{
                                    required: { value: true },}}
                                  id="coordinates"
                                  
                                />
                              </div>
                            </Col> 
                        </Row>
                        
                        <Row>
                          <div className="mb-3">
                            <Label className="form-label " htmlFor="price">Description</Label>
                              <Input
                                type="textarea"
                                id="textarea"
                                defaultValue={this.state.description?this.state.description:""}
                                rows="3"
                                placeholder="About Destination"
                              />
                          </div>
                        </Row>                    
                        <Row>
                          <Col md="12">
                            <Dropzone
                              accept='.jpeg,.jpg,.JPG,.JPEG,.PNG,.png'
                              maxSize={1000000}
                              onDrop = {(acceptedFiles, fileRejections) => {
                                this.handleRejectedFiles(fileRejections)
                                this.handleAcceptedFiles(acceptedFiles)
                                }}
                              >
                              {({ getRootProps, getInputProps }) => (
                              <div className="dropzone">
                                  <div
                                  className="dz-message needsclick"
                                  {...getRootProps()}
                                  >
                                  <input {...getInputProps()} />
                                  <div className="mb-3">
                                      <i className="display-4 text-muted ri-upload-cloud-2-line"></i>
                                  </div>
                                  <h6>Drop only jpeg/png Images here or click to upload.</h6>
                                  <h6>Images size is less than 1 MB.</h6>
                                  </div>
                              </div>
                              )}
                            </Dropzone>
                                <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                >
                                    {this.state.selectedFiles.map((f, i) => {
                                    return (
                                        <Card
                                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                        key={i + "-file"}
                                        >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                            <Col className="col-auto">
                                                <img
                                                data-dz-thumbnail=""
                                                height="80"
                                                className="avatar-sm rounded bg-light"
                                                alt={f.name}
                                                src={f.preview}
                                                />
                                            </Col>
                                            <Col>
                                                <Link
                                                to="#"
                                                className="text-muted fw-bold"
                                                >
                                                {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                <strong>{f.formattedSize}</strong>
                                                </p>
                                            </Col>
                                            </Row>
                                        </div>
                                        </Card>
                                    );
                                    })}

                                {this.state.rejectedFiles.length > 0?
                                  <>
                                    <hr></hr>
                                    <p style={{ color: "red", padding: 5, margin: 0, fontSize: 14 }}>
                                      {"Rejected Files: File size is grater than 1 MB or Invalid File Format"}
                                    </p>
                                  </>
                                :""}
                               {this.state.rejectedFiles.map((f, i) => {
                                return (
                                    <Card
                                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                    key={i + "-rejected_file"}
                                    >
                                    <div className="p-2">
                                        <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                            data-dz-thumbnail=""
                                            height="80"
                                            className="avatar-sm rounded bg-light"
                                            alt={f.name}
                                            src={f.preview}
                                            />
                                        </Col>
                                        <Col>
                                            <Link
                                            to="#"
                                            className="text-muted fw-bold"
                                            >
                                            {f.name}
                                            </Link>
                                            <p className="mb-0">
                                            <strong>{f.formattedSize}</strong>
                                            </p>
                                        </Col>
                                        </Row>
                                    </div>
                                    </Card>
                                  );
                                  })}
                              </div>
                            </Col>
                        </Row> 
                        </>
                        :""}
                         
                    </CardBody>
                  </Card>
                </Col>
                {this.state.is_destination||this.state.is_place?  
                  <Col xl="6">
                    <Card>
                      <CardBody> 
                        <h4 className="card-title">Additional Detail</h4>
                          <Row>
                            <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="elevation">Elevation (M)</Label>
                                <AvField
                                  name="elevation"
                                  placeholder="Elevation"
                                  value={this.state.elevation}
                                  type="text"
                                  className="form-control"
                                  id="elevation"
                                  
                                />
                              </div>
                            </Col> 
                            <Col md="6">
                              <div className="mb-3">
                                <Label className="form-label " htmlFor="area">Area (km²)</Label>
                                <AvField
                                  name="area"
                                  value={this.state.area}
                                  placeholder="Area"
                                  type="text"
                                  className="form-control"
                                  id="area"
                                  
                                />
                              </div>
                            </Col> 
                          </Row> 
                          <Row>
                            <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="weather">Weather</Label>
                                  <AvField
                                    name="weather"
                                    placeholder="Weather"
                                    value={this.state.weather}
                                    type="text"
                                    className="form-control"
                                    id="weather"
                                    
                                  />
                                </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="climate">Climate</Label>
                                  <AvField
                                    name="climate"
                                    placeholder="Climate"
                                    value={this.state.climate}
                                    type="text"
                                    className="form-control"
                                    id="climate"
                                    
                                  />
                                </div>
                            </Col> 
                          </Row>
                          <Row>
                            <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Nearest Bus Station</Label>
                                  <Select 
                                  value={selectedBusStation}
                                  onChange={this.handleSelectedBusStation}
                                  options={PlacesGroup}
                                  onInputChange={(e) => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=${e}`)}
                                  components={{ Menu: AddPlaces }}
                                  classNamePrefix="select2-selection"
                                  />
                              </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="bus_station_distance">Distance to the Bus Station (Km)</Label>
                                  <AvField
                                    name="bus_station_distance"
                                    placeholder="Distance to the Railway Station"
                                    value={this.state.bus_station_distance}
                                    type="text"
                                    className="form-control"
                                    id="bus_station_distance"
                                    
                                  />
                                </div>
                            </Col> 
                          </Row>
                          <Row>
                            <Col md="6">
                              <div className="mb-3">
                                  <Label className="form-label">Nearest Railway Station</Label>
                                  <Select 
                                  value={selectedRailway}
                                  onChange={this.handleSelectedRailway}
                                  options={PlacesGroup}
                                  onFocus={() => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=rail`)}
                                  components={{ Menu: AddPlaces }}
                                  classNamePrefix="select2-selection"
                                  />
                              </div>
                            </Col> 
                            <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="railway_distance">Distance to the Railway Station (Km)</Label>
                                  <AvField
                                    name="railway_distance"
                                    placeholder="Distance to the Railway Station"
                                    value={this.state.railway_distance}
                                    type="text"
                                    className="form-control"
                                    id="railway_distance"
                                    
                                  />
                                </div>
                            </Col> 
                          </Row>
                          <Row>
                            <Col md="6">
                                <div className="mb-3">
                                      <Label className="form-label">Nearest Airport</Label>
                                      <Select 
                                      value={selectedAirport}
                                      onChange={this.handleSelectedAirport}
                                      options={PlacesGroup}
                                      onFocus={() => this.handleLoadNearestPlaces(`state__id=${selectedState.value}&search=airport`)}
                                      components={{ Menu: AddPlaces }}
                                      classNamePrefix="select2-selection"
                                      />
                                  </div>
                                  
                              </Col> 
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label " htmlFor="airport_distance">Distance to the Airport (Km)</Label>
                                  <AvField
                                    name="airport_distance"
                                    placeholder="Distance to the Airport"
                                    value={this.state.airport_distance}
                                    type="text"
                                    className="form-control"
                                    id="airport_distance"
                                    
                                  />
                                </div>
                            </Col> 

                          </Row>
                          {this.state.is_destination?
                            <>
                              {Array.from(Array(this.state.count)).map((c,  index)=> {
                                    return (
                                        <Row>
                                          <Col md="6">
                                            <div className="mb-3">
                                                <Label className="form-label">Destination</Label>
                                                <Select 
                                                onInputChange = {this.onInputChange}
                                                onChange={(e) => this.handleSelectedDestinationsDistance(e, index)}
                                                options={All_DestinationGroup}
                                                classNamePrefix="select2-selection"
                                                />

                                            </div>
                                          </Col>
                                          <Col md="6">
                                              <div className="mb-3">
                                                <Label className="form-label" htmlFor={`diatance-${index}`}>Distance From Destination (Km)</Label>
                                                <AvField
                                                  name="destination_distance"
                                                  placeholder="Distance From Destination"
                                                  type="text"
                                                  className="form-control"
                                                  id={`diatance-${index}`} 
                                                />
                                              </div>
                                            </Col> 
                                        </Row>
                                      )
                                    })}
                              
                                
                                  <Button type="button" className="btn-sm" onClick={this.addInput} color="info"><i className=" fas fa-plus"></i></Button>
                                  {" "}
                                  {this.state.count >1 ? <Button className="btn-sm" type="button" onClick={this.removeInput} color="danger"><i className=" fas fa-minus"></i></Button>
                                  :""}
                              </>
                          :""}
                                          
                          <FormGroup className="mb-1 mt-3">
                            {this.state.loading?(
                              <Spinner className="me-2 mt-2" color="primary" />
                            ):(
                              <div>
                          
                            <Button type="submit" color="primary" className="me-1">
                              Submit
                          </Button>{" "}
                            <Button type="button" onClick={() => this.props.history.goBack()} color="secondary">
                              Cancel
                          </Button>
                          </div>
                            )}
                          
                          
                        </FormGroup>      

                      </CardBody>
                    </Card>
                  </Col>
                  :""}
              </Row>
            </AvForm>
            <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_state}
                 toggle={this.tog_state}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_state: false })}>
                 Add State
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddStateSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="name">State Name</Label>
                           <AvField
                             name="name"
                             placeholder="State Name "
                             type="text"
                             errorMessage="Enter State Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.stateloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>
             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_city}
                 toggle={this.tog_city}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_city: false })}>
                 Add City
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddCitySubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="city">City Name</Label>
                           <AvField
                             name="name"
                             placeholder="City Name "
                             type="text"
                             errorMessage="Enter City Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="city"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.cityloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>

             <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
                 isOpen={this.state.model_place}
                 toggle={this.tog_place}
                 centered={true}
               >
                 <ModalHeader toggle={() => this.setState({ model_place: false })}>
                 Add Place
                 </ModalHeader>
                 <ModalBody>
                   <AvForm className="needs-validation" onValidSubmit={this.handleAddSubPlacesSubmit} >
           
                     <Row>
                       <Col md="6">
                         <div className="mb-3">
                           <Label className="form-label " htmlFor="place_name">Place Name</Label>
                           <AvField
                             name="place_name"
                             placeholder="Place Name"
                             type="text"
                             errorMessage="Enter City Name"
                             className="form-control"
                             validate={{ required: { value: true } }}
                             id="place_name"
                             
                           />
                         </div>
                       </Col> 
                     </Row>
                                       
                     <FormGroup className="mb-0">
                       {this.state.placeloading?(
                         <Spinner className="me-2 mt-2" color="primary" />
                       ):(
                         <div>
                     
                       <Button type="submit" color="primary" className="me-1">
                         Submit
                       </Button>
                       </div>
                         )}
                     </FormGroup>     
                   </AvForm>

                 </ModalBody>
               </Modal>
             </Col>

          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default AddLocation;
